
export let esMessages={

  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Contraseña",
  "remember":"Recordarme",
  "forget":"¿Ha olvidado la contraseña?",
  "sign in":"Iniciar sesión",
  "login":"Login",
  "sign up now":"Registrarse ahora",
  "apply":"Solicitar ahora",
  "contact us":"Contacte con nosotros",
  "Privacy Policy":"Política de privacidad",
  "Terms of Use":"Términos de uso",
  "copyright":"Copyright ©2017, Medtrum Technologies Inc. Todos los derechos reservados.",

  "chooseLang":"Seleccione su país o idioma",
  "asia":"Asia",
  "europe":"Europa",

  "applyHcp":"Solicitar una cuenta PCM",
  "sign up":"Registrarse",
  "Patient":"Paciente",
  "Caregiver":"Cuidador",
  "Email":"Email",
  "Mobile":"Móvil",
  "Enter email":"Introduzca su email.",
  "Enter mobile":"Introduzca su número de móvil.",
  "Verification":"Código de verificación",
  "Invitation":"Invitation code",
  "full name":"Introduzca su nombre completo",
  "Enter pass":"Vuelva a introducir la contraseña.",
  "org":"Organización",
  "Register":"Registrarse",
  "send":"Enviar",
  "agree":"He leído y estoy de acuerdo ",
  "privacy":"con la política de privacidad  ",
  "and" :"y ",
  "use":"los términos de servicio.",
  "errtip1-1":"Debe introducir un email correcto,que se ",
  "errtip1-2":"convertirá en su nombre de usuario Medtrum.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Código de verificación incorrecto",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Nombre de usuario incorrecto",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Introduzca su organización.",

  "errp1":"La contraseña debe contener al menos 3 tipos de los siguientes caracteres: ",
  "errp2":"mayúsculas, minúsculas, número y caracteres especiales.",
  "errp3":"La contraseña debe tener entre 6 y 20 caracteres.",
  "errp4":"La contraseña debe ser diferente del nombre de usuario.",
  "errp5":"La contraseña será inválida si tiene 3 números consecutivos (p.e.: 123 321).",
  "errp6":"La contraseña será inválida si tiene 3 letras consecutivas (p.e.: abc, cba).",
  "errp7":"La contraseña no puede contener espacios.",


  "Find account":"Recuperar su contraseña.",
  "Enter username":"Introduzca su nombre de usuario.",
  "Next":"Siguiente",
  "Cancel":"Cancelar",
  "Back":"Volver atrás",
  "Enter veri":"Enter verification code",
  "Verify notice":"Encuentre el código de verificación enviado por email.",
  "Create new":"Crear una contraseña nueva",
  "Create new notice":"Cree una contraseña nueva. Su contraseña debe tener 6 o más caracteres.",
  "New pass" :"Contraseña nueva",
  "Completed":"Completado",
  "Created":"Contraseña nueva creada.",
  "Login Now":"Iniciar sesión ahora",

  "Delete":"Eliminar",
  "New Patient":"Nuevo paciente",
  "Add Patient":"Añadir paciente",
  "Filter":"Filtro",
  "Name":"Nombre",
  "Gender":"Sexo",
  "Age":"Edad",
  "Type":"Tipo",
  "Duration":"Duración",
  "Connections":"Creador de la cuenta",
  "UploadTime":"Tiempo de carga",
  "Year":"años",
  "Years":"años",
  "Month":"mes",
  "Month2":"Mes",
  "Months":"mes",
  "Invite":"Invitar",
  "Invited":"Invitado/a",
  "All":"Todo",
  "Female":"Mujer",
  "Male":"Hombre",
  "Not Set":"Not Set",
  "Type 1":"Tipo 1",
  "Type 2":"Tipo 2",
  "Gestational":"Gestacional",
  "Prediabetes":"Prediabetes",
  "LADA":"Tipo 1.5 LADA",
  "Apply":"Aplicar",
  "disUn":"Tipo de diabetes no especificado",
  "ageUn":"Edad no especificada",
  "genUn":"Sexo no especificado",
  "addP":"Añadir paciente",
  "newP":"Nuevo paciente",
  "findP":"Encontrar paciente",

  "GDRNF":"No especificado",
  "GDRF":"Mujer",
  "GDRM":"Hombre",
  "女":"Hombre",

  "DBTNF":"No especificado",
  "DBT1":"Tipo 1",
  "DBT2":"Tipo 2",
  "DBTLADA":"Tipo 1.5 LADA",
  "DBTPRE":"Prediabetes",
  "DBTGEST":"Gestacional",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"No especificado",
  "unspecif":"No especificado",
  "register":"Paciente",
  "hcp":"Médico clínico",

  "BG":"GS",
  "CARB":"Carbs",
  "INS":"Inyección",
  "EXR":"Ejercicio",
  "OTR":"Otro",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Cetona en orina",
  "HEL":"HEL",
  "OTR1":"Otro",
  "Loading":"Cargando",

  "home":"Hogar",
  "pID":"ID del paciente",
  "fullName":"Nombre completo",
  "gender":"Sexo",
  "height":"Altura",
  "weight":"Peso",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Fecha de nacimiento",
  "disType":"Tipo de diabetes",
  "disDate":"Fecha de diagnóstico",
  "Address":"Dirección",
  "Postcode":"Código Postal",
  "Inpatient":"Paciente hospitalizado",
  "Yes":"Sí",
  "No":"No",
  "Pno":"Nº de paciente",
  "Bno":"Nº de cama",
  "create":"Crear",
  "Telephone":"Teléfono",

  "enterU":"Introduzca el nombre de usuario (email)",
  "search":"Búsqueda",
  "noU":"Se requiere el nombre de usuario.",
  "searchR":"Resultados de la búsqueda",
  "uername":"Nombre de usuario",
  "alias":"Alias",
  "remove":"Eliminar",
  "viewG":"Visualizar gráficas",
  "sendR":"Enviar solicitud",
  "rSent":"Su solicitud ha sido enviada.",
  "cancelR":"Cancelar petición",

  "VcodeTip1":"¿No lo ha recibido? Espere un minuto e",
  "VcodeTip2":"Inténtelo de nuevo.",
  "VcodeTip3":"Le acabamos de enviar un código de verificación a",
  "Entercode":"Introducir código",
  "Getcode":"Obtener código",

  "messages":"Mensajes",
  "profile":"Perfil",
  "sign out":"Cerrar sesión",
  "changeP":"Cambiar contraseña",
  "connection":"Conexiones",

  "myP":"Mi perfil",
  "Portrait":"Foto de perfil",
  "Profession":"Profesión",
  "DPRONF":"No especificado",
  "DPROENDOCRIN":"Endocrino",
  "DPRODIABTRA":"Educador de diabetes",
  "DPRONURSE":"Enfermero/a",
  "DPRODIATIT":"Dietista",
  "DPROOTR":"Otros PCM",
  "Organization":"Organización",
  "Bio":"Bio",
  "save":"Guardar",
  "oldPa":"Contraseña antigua ",
  "newPa":"Contraseña nueva",
  "RePa":"Vuelva a introducir la contraseña.",
  "forgetY":"¿Ha olvidado su contraseña?",
  "applyM":"Aplicar",
  "oldErr":"La contraseña antigua es incorrecta.",
  "EntTheSame":"Introduzca la nueva contraseña de nuevo.",
  "EnterOld":"Introduzca la contraña antigua.",

  "pList":"Lista de pacientes",
  "connections":"Conexiones",
  "settings":"Configuración",
  "monitor":"Monitorización",
  "graphs":"Informes",
  "events":"Eventos",
  "records":"Historial",
  "qPrint":"Impresión rápida",

  "sensorIn":"Info. del sensor",
  "timeOfLaRead":"Hora de la última lectura del sensor",
  "tranSn":"NS del transmisor:",
  "status":"Estado",
  "sensorLife":"Vida útil restante del sensor",
  "lastSenorRead":"Última lectura del sensor",
  "TranBattery":"Batería del transmisor",
  "sg":"GSe",
  "alert":"Alerta",
  "target":"Objetivo",
  "hypo":"Hipo",
  "sensorGlucose":"Glucosa del sensor (GSe)",
  "calib":"Calibrado",
  "newSen":"Nuevo sensor",
  "warm":"Calentamiento",
  "InsulinPump":"Bomba de insulina",
  "timeOfLaPump":"Hora de los últimos datos de la bomba",
  "pumpSN":"NS de la base de la bomba",
  "ReserviorLife":"Vida útil restante del parche de depósito",
  "InsulinLeft":"Insulina restante",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Basal diaria total",
  "lastBolus":"Último bolus",
  "activeInsulin":"Insulina activa",
  "totalBolus":"Bolus diario total",
  "tampBasal":"Basal Temp",
  "normalBolus":"Bolus Normal",
  "extendBolus":"Bolus Extendido",
  "manualStop":"Manual Suspendido",
  "autoStop":"Auto. Suspendido",
  "auto suspend":"Auto. Suspendido",
  "stop":"Suministro Detenido",
  "newPatch":"Nuevo parche",
  "tempBasal":"Basal Temp",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Configuración de Informes",
  "dataSource":"Fuente de datos",
  "unit":"Unidad",
  "glucoseTarget":"Rango Objetivo de Glucosa",
  "overall":"General",
  "Hypoglycemia":"Hipoglucemia",
  "timePeriod":"Periodo de tiempo",
  "postMeal":"Análisis después de comida",
  "Breakfast":"Desayuno",
  "Lunch":"Almuerzo",
  "Dinner":"Cena",
  "night":"Hora de noche",
  "Before":"Antes",
  "After":"Después",
  "Low":"Baja",
  "High":"Alta",
  "From":"Desde",
  "To":"Hasta",
  "Hours":"horas",
  "Reset":"Restaurar predeterminados",
  "RealTime":"Tiempo real",
  "uploaded":"Descargado",
  "sensor":"Sensor",
  "pdmSN":"NS del PDM",
  "startTime":"Hora de inicio",
  "endTime":"Hora de finalización",
  "uploadTime":"Tiempo de carga",
  "pdm":"PDM",
  "Uploaded":"Descargado",
  "Patch Pump":"Patch Pump",
  "overLapp":"Sessions overlapped",

  // "dashboard":"Panel de mandos",

  "daily":"Resumen diario",
  "date":"Fecha",
  "print":"Imprimir",
  "carbs":"Carbohidratos",
  "exercise":"Ejercicio",
  "heavy":"Pesado",
  "Medium":"Medio",
  "Light":"Ligero",
  "dailyReport":"Informe Resumen Diario",
  "devices":"Dispositivos",
  "tran":"Transmisor",
  "pumpBase":"Base de bomba",
  "HbA1c":"HbA1c",
  "statics":"Estadísticas",
  "glucose":"Glucosa",
  "item":"Elemento",
  "BG1":"GS",
  "SG1":"GSe",
  "avgSD":"Media (mmol/L)±SD",
  "avgSD1":"Media±SD",
  "min":"Mín",
  "max":"Máx",
  "ofRead":"# de lecturas",
  "ofHypo":"# de hipo/duración(min)",
  "ofAlert":"# de alertas",
  "insulin":"Insulina",
  "insulin2":"Insulina",
  "totalDose":"Dosis diaria total",
  "foodBolus":"Bolus de comida",
  "Food+coor":"comida+corr",
  "calibBolus":"Bolus correctivo",
  "durationStop":"Duración de la suspensión (min)",
  "ofPumpAlert":"# de alarmas de bomba",
  "ofMeal":"# de comidas",
  "totalExerTime":"Tiempo total de ejercicio",
  "exerNum":"# de ejercicios",
  "avgInten":"Intensidad media",
  "target1":"Objetivo",
  "high1":"ALTA",
  "low1":"BAJA",
  "BG Reading":"Lecturas GS",

  "dayByday":"Vista general del día a día",
  "dayBydayRe":"Informe de vista general del día a día",
  "period":"Periodo",

  "sensorOverlay":"Superposición del sensor",
  "set":"Configurar",
  "setPeriod":"Configurar periodo",
  "Weekdays":"Días entre semana",
  "Weekends":"Fines de semana",
  "Mon":"Lun",
  "Tue":"Mar",
  "Wed":"Mie",
  "Thur":"Jue",
  "Thu":"Jue",
  "Fri":"Vie",
  "Sat":"Sáb",
  "Sun":"Dom",
  "Average":"Media",
  "sensorOlRe":"Informe de superposición del sensor",
  "Avg":"Media",
  "±SD":"±SD",
  "ofhypo":"# de Hipo",
  "Everyday":"Cada día",

  "TrendAna":"Análisis de tendencia",
  "TrendRe":"Informe de análisis de tendencia",
  "sensorGlu":"Glucosa del sensor ",
  "ofBGtest":"# de pruebas de GS",
  "Basics":"Básicas",
  "static":"Estadísticas",
  "Med":"Med",
  "med":"median",
  "Q1":"C1",
  "Q3":"C3",
  "Q11":"C1",
  "Q31":"C3",
  "IQR":"RIC",
  "SD":"SD",
  "CV":"CV",
  "SE1":"EE de la Media",
  "distri":"Distribución",
  "stab":"Estabilidad",
  "#high":"# de alta",
  "#low":"# de baja",
  "aucBelow":"ABC bajo el límite",
  "aucAbove":"ABC encima del límite",
  "bgRead":"Lecturas GS",
  "total":"Total",
  "ofBolus":"# de bolus",
  "avgBolus":"Bolus de media",
  "Dura1":"Duración (min)",
  "Avg/Total":"Media/Total",
  "high":"Alta",
  "low":"Baja",
  "#hypo":"# de Hipo",
  "ofExer":"# de ejercicios",

  "logbook":"Registro",
  "dailyTotal":"Total Diario",
  "High Glucose":"Glucosa Alta",
  "Low Glucose":"Glucosa Baja",
  "No Active Patch":"No parche activo",
  "Missed Meal":"Comida perdida",
  "Multiple BG Readings":"Lecturas GS múltiples",
  "Stop Patch":"Detener parche",
  "Others":"Otros",
  "Other Events":"Otros Eventos",
  "logRe":"Informe de registro",

  "DeviceSetting":"Revisión de configuración del dispositivo",
  "Insulin Pump":"Bomba de insulina",
  "MaxBasalRate":"Tasa Basal Máxima",
  "BasalPatterns":"Patrones Basales",
  "Selected Basal Pattern":"Seleccione un patrón basal",
  "Maximum Bolus":"Bolus Máximo",
  "Combo/Extended Bolus":"Bolus Combo/Extendido",
  "BG Reminder":"Recordatorio GS",
  "Bolus Increment":"Incremento de Bolus",
  "Bolus Calculator":"Calculadora Bolus",
  "Active Insulin Time":"Tiempo de insulina activa",
  "IC Ratios":"Ratios IC ",
  "Insulin Sensitivity":"Sensibilidad de insulina",
  "BG Target":"Objetivo GS",
  "Bolus Reminder":"Recordatorio de bolus",
  "CGM":"CGM",
  "CGM System":"Sistema CGM",
  "Glucose Unit":"Unidades de Glucosa",
  "Glucose Limits":"Límites de glucosa",
  "Predicitive Alerts":"Alertas predictivas",
  "Rate Alerts":"Alertas de ratio",
  "type":"Tipo",
  "time":"Hora",
  "data":"Fecha",
  "Rate":"Ratio",
  "Calibration Reminder":"Recordatorio de calibrado",
  "Calibration Repeat":"Repetir calibrado",
  "Snooze":"Silenciar",
  "Audio Options":"Opciones de audio",
  "Confidence Reminder":"Recordatorio de confianza",
  "Backlight":"Retroiluminación",
  "Sec":"Seg",
  "Alarm Clock":"Despertador",
  "Patch Expiration":"Caducidad del parche",
  "Sensor Expiration":"Caducidad del sensor",
  "Hourly Max":"Máx por hora",
  "Daily Max":"Máx diario",
  "Low Reservoir":"Depósito bajo",
  "Low Suspend":"Suspender Bajo",
  "Predictive Low Suspend":"Suspender Bajo Predictivo",
  "Rise":"Subida",
  "Fall":"Bajada",
  "Auto Off":"Auto Desact",
  "Standard":"Estándar",
  "Exercise":"Ejercicio",
  "Holiday":"Vacaciones",
  "ProgramA":"Patrón A",
  "ProgramB":"Patrón B",
  "--":"--",
  "Insulin":"insulina",

  "SUSA":"Auto Desact.",
  "SUSHM":"Sobrepasa el máx. suministro de 1 hora",
  "SUSDM":"Sobrepasa la DDT Máx",
  "SUSLSG":"Suspender Bajo",
  "SUSPLSG":"Suspender Bajo Predictivo",
  "Pump Restarted":"Bomba restaurada",
  "Meter BG Now":"Medir GS Ahora",
  "Sensor Exp in 2 Hours":"Sensor caduca en 2 Horas",
  "Sensor Exp in 6 Hours":"Sensor caduca en 6 Horas",
  "Sensor Exp in 30 Min":"Sensor caduca en 30 Min",
  "Sensor Calibration Error":"Error Calib Sensor",
  "Sensor Error":"Sin lecturas",

  "Device Settings Report":"Informe de configuración de dispositivo",
  "24h Total":"24H totales",
  "Device Settings at":"Configuración del dispositivo alas",
  "Start":"Inicio",
  "Combo/Ext Bolus":"Bolus Combo/Extendido",
  "Time Format":"Formato de hora",
  "Device Options（CGM System)":"Opciones de dispositivo (Sistema CGM)",
  "Device Options（Insulin Pump)":"Opciones de dispositivo (Bomba de insulina)",
  "Dispay Settings (Screen)":"Configuración de pantalla (pantalla)",
  "Dispay Settings (Backlight)":"Configuración de pantalla (retroiluminación)",
  "Graph Range":"Rango de gráfica",
  "Range":"Rango",
  "Repeat":"Repetir",
  "Glucose Alerts":"Alertas de glucosa",
  "Alert Silence":"Silenciar Alerta",

  "Create":"Crear",
  "Event Filter":"Filtro de evento",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Cetona en orina",
  "Injection":"Inyección",
  "Other":"Otro",
  "Event Type":"Tipo de evento",
  "Details":"Detalles",
  "Notes":"Notas",
  "Source":"Fuente",
  "edit":"Editar",
  "Action":"Acción",
  "EventReport":"Informe Resumen Evento",
  "By Date":"Por Fecha",
  "By Category":"Por Categoría",
  "Event Summary":"Resumen de evento",
  "No data":"No hay datos",
  "No1":"Sin",
  "data1":"datos",
  "#":"#",
  "BG Summary":"Resumen GS",
  "Carbs Summary":"Resumen Carbs",
  "Injection Summary":"Resumen Inyección",
  "Exercise Summary":"Resumen Ejercicio",
  "Input Notes":"Introducir una nota",

  "Profile":"Perfil",
  "Complications":"Complicaciones",
  "Concomitant diseases":"Enfermedades concurrentes",
  "Suggestion":"Sugerencia",
  "Coronary heart disease":"Cardiopatía coronaria",
  "High blood lipids":"Lípidos de hipertensión",
  "High blood pressure":"Hipertensión arterial",
  "Kidney disease":"Enfermedad del riñón",
  "Neuropathy":"Neuropatía",
  "Obesity":"Obesidad",
  "Peripheral arterial disease":"Enfermedad arterial periférica",
  "Retinopathy":"Retinopatía",
  "Smoking addiction":"Adicción al tabaco",
  "Enter date":"Introduzca la fecha",
  "Enter suggestion":"Introduzca la sugerencia",
  "Enter Notes":"Introduzca la nota",
  "Select":"Seleccionar",
  "Prescription":"Prescripción",
  "Medicine":"Medicina",
  "Dose":"Dosis",
  "Enter medicine":"Introduzca la medicina",
  "Enter dose":"Introduzca la dosis",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Añadir nota",
  "Add Content":"La longitud máxima es de 1000 caracteres.",
  "Other suggestions":"Otras sugerencias",
  "OK":"Aceptar",
  "HCP":"PCM",
  "Content":"Contenido",
  "Records Report":"Informe de registros",

  "Quick Print":"Impresión rápida",
  "Quick Print Settings":"Configuración de la impresión rápida",
  "Select duration":"Seleccionar duración",
  "One Week":"Una semana",
  "One Month":"Un mes",
  "One Quarter":"Un trimestre",
  "End date":"Fecha de finalización",
  "Yesterday":"Ayer",
  "Last Sunday":"Último domingo",
  "Last Saturday":"Último Sábado",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Personalizar",
  "Week Filter":"Filtro de semana",
  "Select reports to print":"Seleccione los informes a imprimir",
  "Daily Summary":"Resumen diario",
  "Day By Day Overview":"Vista general del día a día",
  "Sensor Overlay":"Superposición del sensor",
  "Trend Analysis":"Análisis de tendencia",
  "Logbook":"Registro",
  "Device Settings Review":"Revisión de configuración del dispositivo",
  "createReport":"Crear informe",

  "Segment Analysis":"Análisis de segmento",
  "Sensor Glucose Profile":"Perfil de glucosa del sensor",
  "# of Boluses":"# de bolus",
  "Bolus Insulin":"Insulina de bolus",
  "Basal Pattern":"Patrón basal",
  "Segment Analysis Report":"Informe de análisis de segmento",
  "Avg Glucose":"Glucosa de media",
  "Below":"Inferior a",
  "In Target Range":"En rango objetivo",
  "Coefficient of variation":"Coeficiente de variación",
  "% Time CGM Active":"& tiempo de CGM activo",
  "est_a1c_t1":"A1C estimado: ",
  "est_a1c_t2":"calculado a partir de valores de GS",
  "est_a1c_t3":"Nota: A1C estimado no sustituye la medición de laboratorio",


  "acceptTip":" ha permitido que visualice de forma remota su información de salud. ",
  "cancelTip":" ha dejado de permitir que visualice de forma remota su información de salud. Puede solicitarlo de nuevo si es necesario.",
  "rejectTip":" ha rechazado su solicitud de visualización remota.",
  "Read":"Lectura",

  "Connection":"Conexión",
  "connections1":"Connections",
  "Add Connection":"Añadir conexión",
  "SG":"GSe",
  "Active Insulin":"Insulina Activa",
  "Stop following":"Detener seguimiento",
  "Enter username (email)":"Introduzca el nombre de usuario (email)",
  "Search results":"Resultados de la búsqueda",
  "Send request":"Enviar solicitud",
  "View graphs":"Visualizar gráficas",
  "Agree":"Estoy de acuerdo",
  "Deny":"Denegar",
  "Remove":"Eliminar",
  "Cancel Requset":"Cancelar solicitud",
  "Remark":"Nota",

  "Warm up":"Calentamiento",
  "Monitoring":"Monitorizando",
  "Transmitter Error":"Error del transmisor",
  "Sensor Failure":"Fallo del sensor",
  "Sensor Expired":"Sensor Caducado",
  "Lost Sensor":"Sensor Perdido",
  "Not Calibrated":"No calibrado",
  "Calibrating":"Calibrando",
  "Calibration Needed":"Calibrado necesario",
  "Calibration Error":"Error de calibrado",
  "Charging Battery":"Batería cargándose",
  "Battery Charged":"Batería cargada",

  "To be filled":"Debe rellenarse",
  "Filled with insulin":"Rellenado con insulina",
  "Priming":"Cebando",
  "Priming completed":"Cebado completado",
  "Inserting needle":"Insertando aguja",
  "Patch activated":"Parche desactivado.",
  "Delivering Basal":"Suministrando Basal",
  "Exceeds Max 1 Hour Delivery":"Sobrepasa el máx. suministro de 1 hora",
  "Exceeds Max TDD":"Sobrepasa la DDT Máx",
  "Suspend":"Suspender",
  "Occlusion Detected":"Oclusión detectada",
  "Patch Expired":"Parche caducado",
  "Empty Reservoir":"Depósito vacío",
  "Patch Error":"Error de parche",
  "Pump Base Error":"Error de base de bomba",
  "Patch Battery Depleted":"Batería de parche agotada",
  "Magnetic sensor not calibrated":"Sensor magnético no calibrado",


  "Patient Profile":"Perfil del peciente",
  "On":"Activar",
  "on":"Activar",
  "Off":"Desactivar",
  "off":"Desactivar",

  "CORONARY_HEART_DISEASE":"Cardiopatía coronaria",
  "HIGH_BLOOD_LIPIDS":"Lípidos de hipertensión",
  "HIGH_BLOOD_PRESSURE":"Hipertensión arterial",
  "KIDNEY_DISEASE":"Enfermedad del riñón",
  "NEUROPATHY":"Neuropatía",
  "OBESITY":"Obesidad",
  "PERIPHERAL_ARTERIAL_DISEASE":"Enfermedad arterial periférica",
  "RETINOPATHY":"Retinopatía",
  "SMOKING_ADDICTION":"Adicción al tabaco",

  "saveTip":"Guardado correctamente.",
  "changePaTip":"Su contraseña ha sido modificada.",
  "enterEmTip":"Introduzca su email.",
  "verErrTip":"Código de verificación incorrecto.",
  "chooseEventTip":"Seleccione los eventos a imprimir",
  "chooseDataTip":"Seleccionar datos a imprimir",
  "dateWrongTip":"La fecha de finalización no puede ser anterior a la fecha de inicio.",
  "infoWrongTip":"Rellene todos los campos requeridos.",
  "createdSuccssTip":"Creado correctamente",
  "selectData":"Seleccionar datos a guardar",

  "acceSu":"Petición de conexión aceptada",
  "acceEr":"No se pudo añadir una nueva conexión",
  "rejeSu":"Petición de conexión rechazada",
  "rejeEr":"No se pudo rechazar la petición",

  "userNotExist":"El nombre de usuario no existe.",
  "Password incorrect":"Contraseña incorrecta.",
  "UserType incorrect":"Tipo de usuario incorrecto",

  "registSuccess":"Su cuenta se ha creado correctamente.",
  "registFailed":"No se pudo registrar una nueva cuenta.",
  "sentSuccess":"Mensaje enviado correctamente",
  "sentFailed":"No se pudo enviar el mensaje",
  "Input error":"Error de entrada",

  "deletePtip":"¿Está seguro/a que desea eliminar estos pacientes?",
  "deleteEvents":"¿Está seguro/a que desea eliminar estos eventos?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"¿Está seguro/a que desea eliminarlos?",
  "confirm":"Confirmar",
  "deleteSuccess":"Eliminado correctamente",
  "deleteFailed":"No se pudo eliminar el elemento",
  "modifySuccess":"Modificado correctamente",
  "modifyFailed":"No se pudo modificar",
  "createSuccess":"Creado correctamente",
  "createFailed":"Fallo en la creación",
  "editSuccess":"Editado correctamente",
  "editFailed":"Fallo en la edición",
  "Time overlapped":"Las sesiones que ha seleccionado se solapan entre sí.",
  "showAlert":"Mostrar alertas",

  "dashboard":"Panel de mandos",
  "dboard_glucose_statistics":"Estadísticas",
  "dboard_glucose":"Glucosa",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulina",
  "dboard_carbs":"Carbohidratos",
  "dboard_exercise":"Ejercicio",
  "dboard_glucose_avg":"Media",
  "dboard_cgm_avg":"Media",
  "dboard_insulin_avg":"Dosis Diaria Media",
  "dboard_carbs_avg":"Carbohidratos medios/Diario",
  "dboard_exercise_avg":"Tiempo medio/Diario",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Estadísticas",
  "dboard_BG":"GS",
  "dboard_BG_calibration":"GS/Calibrado (por día)",
  "dboard_SG":"GSe",
  "dboard_AUC_high":"AUC alta >",
  "dboard_AUC_low":"AUC baja <",
  "dboard_highest_value":"Valor más alto",
  "dboard_lowest_value":"Valor más bajo",

  "dboard_pump":"Bomba",
  "dboard_avg_daily_dose":"Dosis Diaria Media",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Basal diario",
  "dboard_daily_bolus":"Bolus diario",
  "dboard_avg_bolus_num":"Nº de bolus medio por día",
  "dboard_avg_suspend_time":"Tiempo de suspensión medio",
  "dboard_avg_reservoir_usage":"Uso de reserva medio",
  "dboard_days":"days",

  "dboard_manual_bolus":"Bolus manual (volumen/nº por día)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Extendido",
  "dboard_combo":"-Combo",

  "dboard_bolus_calculator":"Calculadora de bolus (volumen/nº por día)",
  "dboard_food_bolus":"-Calc. de bolus de comida",
  "dboard_corr_bolus":"-Calc. de bolus de corrección",
  "dboard_override_add":"-Anulación(+)",
  "dboard_override_sub":"-Anulación(-)",

  "dboard_report":"Panel de mandos informe",

  "stopFollow":"¿Está seguro/a de que desea dejar de seguir a este/a paciente?",
  "CancelTip1":"¿Está seguro/a de que desea eliminar esta conexión?",

  "Warning":"Advertencia",
  "agreeConnect":"Si hace clic en 'Aceptar' para aceptar la petición de conexión, sus datos de salud estarán disponibles para la nueva conexión.",
  "denyConnect":"¿Está seguro/a de que desea rechazar la petición de conexión?",
  "deleteConnect":"¿Está seguro/a de que desea eliminar esta conexión? Si lo/la eliminar, la conexión no será capaz de visualizar sus datos de salud.",

  "Choose the events to print":"Seleccione los eventos a imprimir",
  "tryAgain":"Inténtelo de nuevo",
  "username and password is required":"username and password is required",
  "A name is required":"Se requiere un nombre.",
  "username is required":"Se requiere el nombre de usuario.",
  "The date choose wrong":"La fecha elegida es incorrecta",
  "Date no more than 14 days":"No puede seleccionar más de 14 días.",

  "CancelTip":"¿Está seguro/a de que desea eliminar la conexión?",
  "removeConnect":"Eliminado correctamente",

  "dateErr1":"You cannot select more than 90 days.",
  "dateErr2":"La fecha de finalización no puede ser anterior a la fecha de inicio.",

  "Not Filled":"No especificado",
  "Today":"Hoy",
  "duration":"Duración",
  "interval":"Interval",
  "7 days":"7 días",
  "14 days":"14 días",
  "30 days":"30 días",
  "90 days":"90 días",
  "g":"g",

  "Sound+Vibrate":"Audio+Vibración",
  "Sound":"Audio",
  "Vibrate":"Vibración",
  "Silent":"No molestar",

  "1":"Una vez",
  "2":"Diariamente",
  "noMes":"No hay ningún mensaje.",
  "noConnect":"No hay ninguna conexión.",
  "Customize":"Personalizar",

  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Ene",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Abr",
  "May":"May",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Ago",
  "Sep":"Sep",
  "Oct":"Oct",
  "Nov":"Nov",
  "Dec":"Dic",
  "ApplyTip":" solicitud para ver sus datos.",
  "noReadings":"Sin lecturas",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Datos cargados",
  "daop_uploaded_data_text":"Los datos provienen de la App EasyTouch o la App EasyView para iPad.",
  "daop_realtime_data":"Datos en tiempo real",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Batería de parche baja",
  "Alerts_Patch_Battery_Depleted":"Batería de parche agotada", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Depósito bajo", // update
  "Alerts_Empty_Reservoir":"Depósito vacío",
  "Alerts_Patch_Expiration_Advisory":"Caducidad recomendada del parche",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Parche caducado", // update
  "Alerts_Patch_Error":"Error de parche",
  "Alerts_Pump_Base_Error":"Error de base de bomba",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Oclusión detectada", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Sobrepasa la DDT Máx", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Sobrepasa el suministro máx de 1 H",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Suspender Bajo Predictivo", // update
  "Alerts_Low_Suspend":"Suspender Bajo",
  "Alerts_Auto_Off":"Auto Desact.", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Sensor Perdido", // update
  "Alerts_Transmitter_Battery_Low":"Batería baja del transmisor",
  "Alerts_Charge_Transmitter":"Cargar Transmisor",
  "Alerts_Sensor_Error":"Sin lecturas",
  "Alerts_Transmitter_Error":"Error del transmisor",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Fallo del sensor",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Medir GS Ahora",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor caduca en 6 Horas",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor caduca en 2 Horas", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensor caduca en 30 Min",
  "Alerts_Sensor_Expired":"Sensor Caducado", // update
  "Alerts_Rapid_Rise":"Subida rápida",
  "Alerts_Rapid_Fall":"Caída Rápida",
  "Alerts_High_Predicted":"Alta predictiva",
  "Alerts_Low_Predicted":"Baja Predictiva",
  "Alerts_High_Glucose":"Glucosa Alta", // update
  "Alerts_Low_Glucose":"Glucosa Baja", // update
  "Alerts_Below_3.1_mmol/L":"Inferior a 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Batería baja del transmisor",

  "Alerts_PDM_Battery_Low":"Pila baja del PDM",
  "Alerts_Replace_Battery":"Cargar PDM ya",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alertas",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Bomba",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Tiempo en el Modo Automático",
  "t1221_Average_SG_SD":"Promedio GS ± DE",
  "t1221_Time_in_Target_Range":"Tiempo en Rango Objetivo",
  "t1221_Time_above_Range":"Tiempo por encima del Rango",
  "t1221_Time_below_Range":"Tiempo por debajo del Rango",
  "t1221_Auto_Basal_per_day":"Auto Basal (por día)",
  "t1221_Auto_Bolus_per_day":"Auto Bolo (por día)",
  "t1221_Auto_Mode_Exits":"Salidas del Modo Automático",
  "t1221_No_Sensor_readings":"No hay lecturas de sensor",
  "t1221_Max_Delivery":"Administración Máxima",
  "t1221_Min_Delivery":"Administración Mínima",
  "t1222_autoModeBasal":"Basal del Modo automático",
  "t1222_autoModeCorrBolus":"Bolo de Corrección del Modo Automático",
  "t1222_autoSnack":"Automático Merienda",
  "t1222_autoBreakfast":"Automático Desayuno",
  "t1222_autoLunch":"Automático Almuerzo",
  "t1222_autoDinner":"Automático Cena",
  "t1222_autoExercise":"Automático Ejercicio",
  "t1222_Snack":"Merienda",
  "t1222_Auto_Mode":"Modo Automático",
  "t1222_Time_in_Auto_Mode":"Tiempo en Modo Automático(%)",
  "t1222_Avg_SD":"Promedio (mg/dL)±DE",
  "t1222_Target_Range":"Rango objetivo(%)",
  "t1222_Above_Range":"Por encima del rango(%)",
  "t1222_Below_Range":"Por debajo del rango(%)",
  "t1222_Auto_Mode_Exits":"# de salidas del modo automático",
  "t1221_Auto_Mode":"Modo Automático",
  "t1222_auto_basal":"Basal Auto",
  "t1222_auto_bolus":"Bolus Auto",
  "t0805_User_Management":"Gestión de usuarios",
  "t0805_Patient_Management":"El manejo del paciente",
  "t0805_Operation_History":"Historial de operaciones",
  "t0805_User_List":"Lista de usuarios",
  "t0805_User":"Usuario",
  "t0805_Time":"Tiempo",
  "t0805_Operation_Type":"Tipo de operación",
  "t0805_Back":"Volver atrás",
  "t0805_Add":"Añadir",
  "t0805_Delete":"Eliminar",
  "t0809_Add_User":"Agregar usuario",
  "t1028_Pattern_C":"Patrón C",
  "t1028_Pattern_D":"Patrón D",
  "t1029_Auto_meal_bolus":"Bolo de comida automático",
  "t1029_Auto_mode_correction_bolus":"Bolo de corrección del modo automático",
  "t1029_Sick":"Enfermo/a",
  "t1029_Auto_Mode_Feature":"Modo Auto Feator",
  "t1029_Target_SG":"GSe Objetivo",
  "t1029_Auto_Meal_Handling":"Gestión Comida Auto",
  "t1029_Total_Daily_Dose":"Dosis Diario Total",
  "t1029_Pump_Light":"Luz de bomba",
  "t1029_Alerts_for_Hypo":"Alertas para Hipo.",
  "t1102_Out_of_Range":"Fuera de rango",
  "t1102_Command_Reminder":"Recordatorio de Mando",
  "t1102_Alarms_Alerts_on_APP":"Alarmas y Alertas de la Bomba",
  "t1102_Alarms_on_App":"Alarmas Act. en la App",
  "t1102_Alerts_on_App":"Alarmas Act. en la App",
  "t1102_Factory_Calibration":"Calibrado de fábrica",
  "t1102_Alerts_for_Low":"Alertas para Baja",
  "t1102_Alerts_for_High":"Alertas para Alta",
  "t1102_Alerts_for_Others":"Alertas para Otros",
  "t1102_Adjustment":"Ajuste",
  "t1102_Suggested":"Sugerido",
  "t1103_Glucose":"Glucosa",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulina",
  "t1103_Carbs":"Carbs",
  "t1103_Exercise":"Ejercicio",
  "t1103_Min_Max":"Mín./Máx.",
  "t1103_Target_Range":"Rango objetivo",
  "t1103_Overall_Tine_In_Range":"Total: Tiempo En Rango",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Modo automático: Tiempo En Rango",
  "t1103_Time_below_range":"Tiempo por debajo del rango",
  "t1103_Time_above_range":"Tiempo por encima del rango",
  "t1103_Time_in_target_range":"Tiempo en rango objetivo",
  "t1103_Incorrect_Password":"Contraseña incorrecta, $1 Intento restante, ingrese la contraseña correcta.",
  "t1103_Incorrect_locked":"Los intentos fallidos superan el límite, la cuenta se ha bloqueado. Vuelva a intentarlo en $1 minutos.",
  "t1104_The_data_is_from":"Los datos provienen de la App EasySense o la App EasyPatch.",
  "t1104_Privacy_Policy":"Política de privacidad y Condiciones de uso",
  "t1104_updated_privacy_policy":"Hemos actualizado nuestra política de privacidad y condiciones de uso. Léalas cuidadosamente y acepte las nuevas condiciones antes de usar EasyPatch.",
  "t1104_Disagree":"No acepto",
  "t1104_Agree":"Estoy de acuerdo",
  "t1105_Upload_History":"Historial de carga",
  "t1105_Delete_Data":"Borrar datos",
  "t1105_Target_Range":"Rango objetivo",
  "t1105_request_to_view_your_data":"Solicitud de $1 para ver sus datos.",
  "t1105_Recent_Updates":"Actualizaciones recientes",
  "t1108_No_data":"No hay datos",
  "t1108_Pump_Bash_SN":"NS de la base de la bomba",
  "t1108_Transmitter_SN":"NS del transmisor",
  "t1112_Normal_Glucose":"Glucosa Normal",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Bolus manual o bolus modificado",
  "t1112_Auto_Mode_Started":"Suministro suspendido",
  "t1112_Auto_Mode_Exit":"Modo Auto Iniciado",
  "t1112_Normal_Bolus":"Bolus normal",
  "t1112_Extended_Bolus":"Bolus extendido",
  "t1112_Combo_Bolus":"Bolus Combo",
  "t1112_Carbs":"Carbohidratos",
  "t1112_Glucose":"Glucosa",
  "t1112_BG":"GS",
  "t1112_Audio":"Audio",
  "t1112_Tone":"Tono",
  "t1112_Audio_Options":"Opciones de audio",
  "t1112_Weight_Unit":"Unidad De Peso",
  "t1112_Height_Unit":"Unidad De Altura",
  "t1112_Not_available":"No Disponible",
  "t1112_Number":"Número",
  "t1112_days":"# días",
  "t1112_min":"min",
  "t1113_days":"días",
  "t1215_Security":"Seguridad",
  "t1215_MFA":"Autenticación multifactor (MFA)",
  "t1215_Enter_verification_code":"Ingrese el código de verificación",
  "t1215_Multi_factor_ON":"La autenticación multifactor está activada. Se ha enviado el código de verificación a $1 Envíe el código de verificación.",
  "t1215_Verification_code_incorrect":"Código de verificación incorrecto",
  "t1215_Show_Glucose_Value":"Mostrar valor de glucosa",
  "t1221_enter_verification_code":"Ingrese el código de verificación de 6 dígitos enviado a $1.",
  "t1221_Verification_Success":"Verificado con éxito",
  "t1222_We_will_only_process":"Solo procesaremos sus datos de cuidado de salud a través de la página web/App de Medtrum con su consentimiento. ",
  "t1222_If_you_are_under_years":"Si es menor de 16 años, necesitará el consentimiento de sus padres o representante legal para registrarse en esta App.",
  "t1221_register_cn":"Tiene el derecho de no cargar datos de dispositivos a la App, en cuyo caso los datos no serán accesibles por otras personas. Si elige no registrarse en la página web/App de Medtrum, el único registro de sus datos de cuidado de salud estará en el mismo dispositivo. ",
  "t1221_register_eu":"Si elige registrarse en su cuenta de Medtrum y acceder a nuestra App usando dicha cuenta, los datos de cuidado de salud registrados en la App serán cargados en nuestras servidores de Europa y se conservarán durante 2 años. Tiene el derecho de no cargar datos de dispositivos a la App, en cuyo caso los datos no serán accesibles por otras personas. Si elige no registrarse en la página web/App de Medtrum, el único registro de sus datos de cuidado de salud estará en el mismo dispositivo.",
  "t1221_register_follow":"Solo procesaremos sus datos de cuidado de salud a través de la página web/App de Medtrum con su consentimiento.",
  "t1222_Terms_of_Use":"las Condiciones de Uso de Medtrum",
  "t1222_Privacy_Policy":"la Política de Privacidad de Medtrum",
  "t1222_Create_Account":"Crear Cuenta",
  "t1222_Back":"Volver atrás",
  "t1222_Verify_your_account":"Verifica tu cuenta",
  "t1222_please_check_your_account":"Enviaremos un código de verificación a $1, verifique su cuenta.",
  "t1222_I_Agree_to":"Estoy de acuerdo con $1",
  "t1223_Invalid_Verification_Code":"Código de verificación invalido. Inténtalo de nuevo.",
}

//export default {esMessages}



// WEBPACK FOOTER //
// ./src/lang/es.js